import { fromJS } from 'immutable';
import {
  ACCOUNT_FETCH_ERROR,
  ACCOUNT_FETCH_REQUEST,
  ACCOUNT_FETCH_SUCCESS,
  ACCOUNT_UPDATE_SUCCESS,
  ACCOUNT_UPLOAD_AVATAR_SUCCESS,
  CANCEL_EMAIL_CHANGE_SUCCESS,
} from './constants';

const initialState = fromJS({
  account: {},
  isFetching: false,
});

export function accountReducer(state = initialState, action) {
  switch (action.type) {
    case ACCOUNT_FETCH_REQUEST:
      return state.set('isFetching', true);
    case ACCOUNT_FETCH_SUCCESS:
      return state.merge({
        account: fromJS(action.payload.userData),
        isFetching: false,
      });
    case ACCOUNT_FETCH_ERROR:
      return state.set('isFetching', false);

    case ACCOUNT_UPDATE_SUCCESS:
      return state.set('account', fromJS(action.payload.userData));

    case CANCEL_EMAIL_CHANGE_SUCCESS:
      return state.setIn(['account', 'pending_email'], null);

    case ACCOUNT_UPLOAD_AVATAR_SUCCESS:
      return state.setIn(['account', 'avatar'], action.payload.avatar);

    default:
      return state;
  }
}
